import {AsapAction} from './AsapAction';
import {AsapScheduler} from './AsapScheduler';

export const asap = new AsapScheduler(AsapAction);



// WEBPACK FOOTER //
// ./~/rxjs/src/scheduler/asap.ts